var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center my-1"},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"grey darken-2"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('h4',{staticClass:"label--text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }